<template>
  <div class="footer">
    <div class="footer-con flex-row">
      <div class="footer-left">
        <img
          class="logo"
          :src="webInfo.logo"
        />
        <div class="company-info flex-col">
          <span>address：{{ webInfo.address }}</span>
          <span>phone：{{ webInfo.phone }}</span>
          <span>email：{{ webInfo.email }}</span>
          <span>fax：{{ webInfo.fax }}</span>
          <span>after-sale service hotline：{{ webInfo.servicePhone }}</span>
        </div>
      </div>
      <div class="grey-white"></div>
      <div class="footer-right justify-start" v-if="isPc">
        <div class="menu-item">
          <h3 @click="toPages('about')">about</h3>
          <div class="menu-item-list flex-col">
            <span @click="toAbout('brief')">brief</span>
            <span @click="toAbout('culture')">culture</span>
            <span @click="toAbout('develop')">development history</span>
            <span @click="toAbout('qualification')">qualification</span>
            <span @click="toAbout('detectability')">detectability</span>
            <span @click="toAbout('project')">project case</span>
            <span @click="toAbout('info')">disclose information</span>
          </div>
        </div>
        <div class="menu-item menu-item2">
          <h3 @click="toPages('products')">products</h3>
          <el-row class="menu-item-list">
            <el-col
              :span="24"
              v-for="item in typeListRes"
              :key="item.prodTypeId"
            >
              <span @click="toPages('products')">{{
                item.prodTypeNameEn
              }}</span>
            </el-col>
          </el-row>
        </div>
        <div class="menu-item">
          <h3 @click="toPages('contact')">contact us</h3>
          <div class="menu-item-list flex-col">
            <span @click="toPages('contact')">contact way</span>
            <span @click="toPages('contact')">join us</span>
          </div>
        </div>
        <div class="menu-item">
          <h3 @click="toWebLink">IR</h3>
        </div>
      </div>
      <div class="qcode">
        <img
          :src="webInfo.wxCodeImage"
        />
        <p>WeChat</p>
      </div>
    </div>
    <div class="bottom justify-between items-end">
      <div>
        {{webInfo.copyrightInfo}}
        <div style="margin-top:4px"  v-html="webInfo.recordNumber" ></div>
      </div>
      <div>技术支持：台商汇信息科技（深圳）有限公司</div>
    </div>
    <div class="fix_btn">
      <el-popover
        placement="left"
        width="100"
        trigger="hover"
        popper-class="wx_popper"
      >
        <img
          :src="webInfo.wxCodeImage"
          style="width: 100px; height: 100px"
        />
        <div class="btn_wx" slot="reference"><img src="../../assets/images/wx.png" /></div>
      </el-popover>

      <el-popover
        placement="left"
        width="120"
        trigger="hover"
        popper-class="wx_popper"
      >
        <div>{{ webInfo.phone }}</div>
        <div class="btn_tel" slot="reference"><em></em></div>
      </el-popover>
      <el-popover
        placement="left"
        width="120"
        trigger="hover"
        popper-class="wx_popper"
      >
        <div class="little_hand" @click="dialogVisible = true">consult</div>
        <div class="btn_join" slot="reference"><em></em></div>
      </el-popover>
      <!-- <div class="btn_top" @click="backTop"><em></em></div> -->
    </div>
    <el-dialog
      title="Welcome to KARON ECO-VALVE, please enter what you need to consult"
      :visible.sync="dialogVisible"
      :width="isPc ? '70%' : '100%'"
      :before-close="handleClose"
    >
      <div class="bottom-pop">
        <el-form ref="form" :model="form">
          <el-form-item
            label="province:"
            prop="area"
            :rules="[
              { required: true, message: 'The province cannot be empty!' },
            ]"
          >
            <el-input v-model="form.area"></el-input>
          </el-form-item>
          <el-form-item
            label="company name:"
            prop="company"
            :rules="[
              { required: true, message: 'The company name cannot be empty!' },
            ]"
          >
            <el-input v-model="form.company"></el-input>
          </el-form-item>
          <el-form-item
            label="contact way:"
            prop="phone"
            :rules="[{ required: true, message: 'The contact way cannot be empty!' }]"
          >
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item
            label="consultation content:"
            prop="consult"
            :rules="[{ required: true, message: 'The consultation content cannot be emptyQ' }]"
          >
            <el-input type="textarea" v-model="form.consult"></el-input>
          </el-form-item>
          <el-form-item label="remark:" prop="remark">
            <el-input type="textarea" v-model="form.remark"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">submit</el-button>
            <el-button @click="resetForm">reset</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getTypeList } from "@/assets/api/products.js";
import { getWebInfo, getConsultSubmit } from "@/assets/api/about.js";

export default {
  data() {
    return {
      typeListRes: [],
      webInfo: {},
      dialogVisible: false,
      form: {
        company: "",
        phone: "",
        consult: "",
        remark: "",
        area:''
      },
    };
  },
  computed: {
    ...mapState(["isPc"]),
  },
  created() {
    getTypeList({
      orderByColumn: "orderNum",
      isAsc: "desc",
      pageNum: 1,
      pageSize: 100,
    }).then((res) => {
      // console.log(res.data);
      this.typeListRes = res.data.data.rows;
      // this.activeType = this.typeListRes[0].prodTypeId;
    });
    getWebInfo().then((res) => {
      this.webInfo = res.data.data;
      this.webInfo.wxCodeImage=this.$imgUrl + this.webInfo.wxCodeImage
      this.webInfo.logo=this.$imgUrl + this.webInfo.logo
    });
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    onSubmit() {
      console.log("submit!");
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm("Do you confirm submission?", "prompt", {
            confirmButtonText: "confirm",
            cancelButtonText: "cancel",
            type: "warning",
          })
            .then(() => {
              getConsultSubmit(this.form).then((res) => {
                console.log(res);
                if (res.data.msg == "操作成功") {
                  this.$message({
                    type: "success",
                    message: "Submitted successfully!",
                  });
                  this.resetForm();
                  this.dialogVisible = false;
                }
              });
            })
            .catch(() => {});
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
    },
    toPages(pageName) {
      this.$router.push({
        path: `/en_${pageName}`,
      });
    },
    toWebLink() {
      window.open("https://ir.p5w.net/c/301151.shtml", "_blank");
    },
    toAbout(type) {
      this.$router.push({
        path: `/en_about?type=${type}`,
      });
    },
    applyForAdmission() {},
    submit() {},
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.footer {
  background: #f8f8fa;
  .footer-con {
    position: relative;
    .qcode {
      position: absolute;
      right: 80px;
      top: 140px;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #2c2c2e;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
      img {
        width: 140px;
        height: 140px;
        object-fit: contain;
        margin-bottom: 8px;
      }
    }
  }
  .footer-left {
    background: rgba($color: #000000, $alpha: 0.04);
    padding: 78px 80px 66px;
    .logo {
      width: 300px;
      height: 50px;
      object-fit: contain;
      margin-bottom: 24px;
    }
    .company-info {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #2c2c2e;
      letter-spacing: 0;
      font-weight: 400;
      span {
        margin-bottom: 12px;
      }
    }
  }
  .grey-white {
    width: 55px;
    height: 100%;
    border-top: 374px solid rgba($color: #000000, $alpha: 0.04);
    border-right: 55px solid #f8f8fa;
  }
  .footer-right {
    padding: 73px 80px;
    .menu-item {
      margin-right: 24px;
      flex: 1;
      h3 {
        font-family: MicrosoftYaHei-Bold;
        font-size: 18px;
        color: #2c2c2e;
        letter-spacing: 0;
        font-weight: 700;
        margin-bottom: 16px;
        cursor: pointer;
        white-space: nowrap;
      }
      .menu-item-list {
        span {
          cursor: pointer;
          opacity: 0.8;
          font-family: MicrosoftYaHei;
          font-size: 16px;
          color: rgba($color: #2c2c2e, $alpha: 0.8);
          letter-spacing: 0;
          font-weight: 400;
          margin-bottom: 12px;
          display: block;
          white-space: nowrap;
        }
      }
    }
    .menu-item2 {
      margin-right: 4px;
      flex: 2.5;
      .menu-item-list {
        margin-right: 20px;
      }
    }
  }
  .bottom {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: rgba($color: #000000, $alpha: 0.32);
    letter-spacing: 0;
    font-weight: 400;
    padding: 20px 80px;
    background: #fff;
  }
  .fix_btn {
    position: fixed;
    top: 50%;
    right: 27px;
    z-index: 99;

    div {
      cursor: pointer;
      width: 48px;
      height: 48px;
      box-shadow: 0px 2px 7px 0px rgba(213, 213, 213, 0.75);
      border-radius: 60px;
      margin-bottom: 16px;
      background-color: #fff;
      background-size: contain;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    div:hover {
      background: rgba(0, 0, 0, 0.04);
    }
    em {
      width: 22px;
      height: 22px;
      display: inline-block;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }
    .btn_wx img {
      width: 22px;
      height: 22px;
      object-fit: contain;
    }
    .btn_tel em {
      background-image: url("../../assets/images/tel.png");
    }
    .btn_top em {
      background-image: url("../../assets/images/top.png");
    }
    .btn_join em {
      background-image: url("../../assets/images/contact-msg.png");
    }
  }
}
@media screen and (max-width: 768px) {
  .footer {
    .footer-con {
      .qcode {
        position: absolute;
        right: auto;
        left: 40px;
        top: auto;
        bottom: 40px;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #2c2c2e;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;
        img {
          width: 140px;
          height: 140px;
          object-fit: contain;
          margin-bottom: 8px;
        }
      }
    }
    .footer-left {
      background: rgba($color: #000000, $alpha: 0.04);
      padding: 40px 0 230px 40px;
      .logo {
        width: 300px;
        height: 50px;
        object-fit: contain;
        margin-bottom: 24px;
      }
      .company-info {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #2c2c2e;
        letter-spacing: 0;
        font-weight: 400;
      }
    }
    .grey-white {
      width: 55px;
      height: 100%;
      border-top: 509px solid rgba($color: #000000, $alpha: 0.04);
      border-right: 50px solid #f8f8fa;
    }
    .bottom {
      flex-direction: column;
      font-size: 12px;
      font-weight: 400;
      padding: 10px 20px;
      align-items: baseline;
      div:first-child {
        margin-bottom: 4px;
      }
    }
  }
}
</style>
<style>
.el-popover {
  box-sizing: content-box;
}
.footer .el-dialog__title {
  font-size: 24px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #2c2c2e;
  line-height: 36px;
}
.footer .el-dialog__headerbtn {
  font-size: 28px;
}
.el-dialog__headerbtn:hover .el-dialog__close {
  color: #005bac;
}
.el-input__inner:focus,
.el-textarea__inner:focus {
  border-color: #005bac;
}
.el-button--primary {
  background-color: #005bac;
  border-color: #005bac;
}
.el-button--default:hover {
  color: #005bac;
  border-color: #005bac;
}
.el-form-item__label {
  font-size: 16px;
}

.footer .el-dialog__header {
  padding-right: 40px;
}
.footer .el-dialog__body {
  padding-right: 20px;
}
</style>


// WEBPACK FOOTER //
// src/en/common/footer.vue